import { Icon } from "@iconify/react";
import { Box, SxProps } from "@mui/system";

interface IconifyProps {
  icon: string;
  sx?: SxProps;
  [key: string]: any;
}

export default function Iconify({
  icon,
  sx = { width: 1, height: 1, objectFit: "cover" },
  ...other
}: Readonly<IconifyProps>) {
  return <Box component={Icon} icon={icon} sx={sx} {...other} />;
}
